import { render, staticRenderFns } from "./PopupInnerPopup.vue?vue&type=template&id=ff5327e8&"
import script from "./PopupInnerPopup.vue?vue&type=script&lang=js&"
export * from "./PopupInnerPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports